export default __webpack_public_path__ + "static/media/checkmark.ad61c906.svg";